import React, { useEffect, useRef } from "react";
import "./Desenvolvimento.css";
import googleImg from "../../assets/google mais.png";
import siteImg from "../../assets/website.png";
import dominioImg from "../../assets/www.png";

function Desenvolvimento() {
  const scrollRef = useRef(null);

  useEffect(() => {
    const container = scrollRef.current;
    let scrollPos = 0;

    const autoScroll = () => {
      if (container) {
        scrollPos += 0.3; // velocidade do carrossel
        if (scrollPos >= container.scrollWidth / 2) {
          scrollPos = 0;
        }
        container.scrollLeft = scrollPos;
      }
      requestAnimationFrame(autoScroll);
    };

    autoScroll();
  }, []);

  return (
    <section className="dev-section" id="desenvolvimento">
      <h2>Nossos serviços oferecem tudo que o seu negócio precisa.</h2>

      <div className="dev-carousel" ref={scrollRef}>
        <div className="dev-track">
          {/* CARD 1 */}
          <div className="dev-card">
            <img src={googleImg} alt="Google Meu Negócio" className="dev-img" />
            <h3>O Google Meu Negócio.</h3>
            <p>
              É uma plataforma gratuita do Google que permite que empresas
              cadastrem informações relevantes sobre seus negócios.
            </p>
          </div>

          {/* CARD 2 */}
          <div className="dev-card">
            <img src={siteImg} alt="Website" className="dev-img" />
            <h3>O desenvolvimento de website.</h3>
            <p>
              Processo completo de criação e manutenção de sites profissionais
              para negócios de todos os tamanhos.
            </p>
          </div>

          {/* CARD 3 */}
          <div className="dev-card">
            <img
              src={dominioImg}
              alt="Domínio e hospedagem"
              className="dev-img"
            />
            <h3>Hospedagem e domínio.</h3>
            <p>
              O domínio é o endereço, e a hospedagem é onde o site fica salvo.
              Os dois juntos tornam seu site acessível.
            </p>
          </div>

          {/* DUPLICAÇÃO PARA LOOP INFINITO */}
          <div className="dev-card">
            <img src={googleImg} alt="Google Meu Negócio" className="dev-img" />
            <h3>O Google Meu Negócio.</h3>
            <p>Permite gerenciar sua presença e atrair clientes.</p>
          </div>

          <div className="dev-card">
            <img src={siteImg} alt="Website" className="dev-img" />
            <h3>O desenvolvimento de website.</h3>
            <p>Sites profissionais feitos sob medida para sua empresa.</p>
          </div>

          <div className="dev-card">
            <img
              src={dominioImg}
              alt="Domínio e hospedagem"
              className="dev-img"
            />
            <h3>Hospedagem e domínio.</h3>
            <p>Garantia de estabilidade, segurança e alta performance.</p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Desenvolvimento;
